import { error as errorNotif } from "react-notification-system-redux";

import { constantService } from "_services";

import { constantTypes } from "../types";

export const constantActions = {
  getProcessingStatuses,
  getProcessingErrors,
  getProductFileTypes,
};

function getProcessingStatuses() {
  return (dispatch) => {
    dispatch(request());

    constantService.getProcessingStatuses().then(
      (processingStatuses) => dispatch(success(processingStatuses.values)),
      (error) => {
        if (!error.isResponse) {
          constantService.crmGetProcessingStatuses().then(
            (processingStatuses) => dispatch(success(processingStatuses.values)),
            (error) => dispatch(failure(error.toString()))
          );
        } else {
          dispatch(failure(error.toString()));
        }
      }
    );
  };

  function request() {
    return { type: constantTypes.GET_PROCESSING_STATUSES_REQUEST };
  }

  function success(payload) {
    return { type: constantTypes.GET_PROCESSING_STATUSES_SUCCESS, payload };
  }

  function failure() {
    return { type: constantTypes.GET_PROCESSING_STATUSES_FAILURE };
  }
}

function getProcessingErrors() {
  return (dispatch) => {
    dispatch(request());

    constantService.getProcessingErrors().then(
      (processingErrors) => dispatch(success(processingErrors.values)),
      (error) => {
        if (!error.isResponse) {
          constantService.crmGetProcessingErrors().then(
            (processingErrors) => dispatch(success(processingErrors.values)),
            (error) => dispatch(failure(error.toString()))
          );
        } else {
          dispatch(failure(error.toString()));
        }
      }
    );
  };

  function request() {
    return { type: constantTypes.GET_PROCESSING_ERRORS_REQUEST };
  }

  function success(payload) {
    return { type: constantTypes.GET_PROCESSING_ERRORS_SUCCESS, payload };
  }

  function failure() {
    return { type: constantTypes.GET_PROCESSING_ERRORS_FAILURE };
  }
}

function getProductFileTypes(products) {
  return (dispatch) => {
    dispatch(request());

    const requests = products.map((product) => constantService.getProductFileTypes(product));

    Promise.all(requests)
      .then((data) => {
        const payload = data.reduce((acc, values, idx) => ({ ...acc, [products[idx]]: values }), {});
        dispatch(success(payload));
      })
      .catch((error) => {
        dispatch(failure());
        dispatch(errorNotif({ title: "Error", message: error.toString() }));
      });
  };

  function request() {
    return { type: constantTypes.GET_PRODUCT_FILE_TYPES_REQUEST };
  }
  function success(payload) {
    return { type: constantTypes.GET_PRODUCT_FILE_TYPES_SUCCESS, payload };
  }
  function failure() {
    return { type: constantTypes.GET_PRODUCT_FILE_TYPES_FAILURE };
  }
}
